import { getTerritoryLabel } from './appStoreTerritories';

/**
 * ARPU bazlı App Store bölge fiyat tier'ları — mirrors
 * api/internal/domain/price_tier.go (RegionPriceTierT1..T4).
 * T1 ayrı bir override alanı değildir: mevcut ana uygulama/ürün fiyatı (mainAppPriceTier /
 * priceTierByLocale) zaten T1'dir. Burada sadece override edilebilen T2-T4 listelenir;
 * boş bırakılan tier'lar Apple'ın otomatik bölge eşitlemesiyle T1 fiyatını kullanır.
 */
export const REGION_PRICE_TIER_T1 = 't1';
export const REGION_PRICE_TIER_T2 = 't2';
export const REGION_PRICE_TIER_T3 = 't3';
export const REGION_PRICE_TIER_T4 = 't4';

const T1_TERRITORIES = [
  'USA', 'CAN', 'GBR', 'DEU', 'FRA', 'ITA', 'ESP', 'NLD', 'BEL', 'AUT',
  'CHE', 'IRL', 'SWE', 'NOR', 'DNK', 'FIN', 'JPN', 'AUS', 'NZL', 'KOR',
  'SGP', 'HKG', 'TWN', 'LUX', 'ISL',
];

const T2_TERRITORIES = [
  'ARE', 'SAU', 'QAT', 'KWT', 'BHR', 'ISR', 'CZE', 'POL', 'PRT', 'GRC',
  'SVK', 'SVN', 'EST', 'LVA', 'LTU', 'HRV', 'HUN', 'MLT', 'CYP', 'CHL',
  'URY', 'PAN', 'CRI', 'MYS', 'CHN',
];

const T3_TERRITORIES = [
  'BRA', 'MEX', 'COL', 'ARG', 'PER', 'ECU', 'DOM', 'GTM', 'TUR', 'ROU',
  'BGR', 'SRB', 'UKR', 'KAZ', 'ZAF', 'THA', 'VNM', 'IDN', 'PHL',
];

const T4_TERRITORIES = [
  'IND', 'PAK', 'BGD', 'LKA', 'NPL', 'NGA', 'KEN', 'GHA', 'CIV', 'EGY',
  'MAR', 'DZA', 'TUN', 'SEN', 'TZA', 'UGA', 'KHM', 'MMR', 'LAO', 'MNG',
  'UZB',
];

export interface RegionPriceTierInfo {
  value: string;
  label: string;
  description: string;
  territories: string[];
}

/** T1 bilgi amaçlı: hangi ülkeler ana/baz fiyatı kullanıyor (override alanı yok). */
export const REGION_PRICE_TIER_T1_INFO: RegionPriceTierInfo = {
  value: REGION_PRICE_TIER_T1,
  label: 'T1 — Yüksek ARPU',
  description: 'Baz fiyat. Diğer tier’lar buradan indirimle türetilir.',
  territories: T1_TERRITORIES,
};

/** Fiyatlandırma ekranında düzenlenebilen override tier'lar (T1 hariç). */
export const REGION_PRICE_TIERS: RegionPriceTierInfo[] = [
  {
    value: REGION_PRICE_TIER_T2,
    label: 'T2 — Orta-yüksek ARPU',
    description: 'Genelde T1’in %60–70’i. Boş bırakılırsa T1 fiyatı kullanılır.',
    territories: T2_TERRITORIES,
  },
  {
    value: REGION_PRICE_TIER_T3,
    label: 'T3 — Orta ARPU, yüksek hacim',
    description: 'Genelde T1’in %35–45’i. Boş bırakılırsa T1 fiyatı kullanılır.',
    territories: T3_TERRITORIES,
  },
  {
    value: REGION_PRICE_TIER_T4,
    label: 'T4 — Düşük ARPU',
    description: 'Genelde T1’in %20–25’i. Boş bırakılırsa T1 fiyatı kullanılır.',
    territories: T4_TERRITORIES,
  },
];

export function regionTierTerritoryLabels(tier: RegionPriceTierInfo): string[] {
  return tier.territories.map(getTerritoryLabel);
}
